import { apiClient } from "../../../services/axiosInstance";
import {
  Article,
  BlogCommentEntity,
  ServerListResponse,
  ServerResponse,
} from "../../../types";

export function getNewsDetail(articleId: string) {
  return apiClient.get<ServerResponse<Article>>(`/v1/news/${articleId}`);
}

export const GET_NEWS_DETAIL_QUERY_KEY = ["news-detail"];

export function getRelatedNews(articleId: number) {
  return apiClient.get<ServerListResponse<Article>>(
    `/v1/news/${articleId}/related`,
  );
}

export const GET_RELATED_NEWS_QUERY_KEY = ["news-related"];

export function postToggleReaction({
  articleId,
  reactionTypeId,
}: {
  articleId: number;
  reactionTypeId: number;
}) {
  return apiClient.post(`/v1/news/${articleId}/toggle-reaction`, {
    meta: [],
    payload: {
      reaction_type_id: reactionTypeId,
    },
  });
}

export const GET_NEWS_COMMENTS_QUERY_KEY = ["news-comments"];

export function getComments({ articleId }: { articleId: number }) {
  return apiClient.get<ServerListResponse<BlogCommentEntity>>(
    `/v1/news/${articleId}/comments`,
  );
}

export function deleteNewsComment({
  articleId,
  commentId,
}: {
  articleId: number;
  commentId: number;
}) {
  return apiClient.post(`/v1/news/${articleId}/delete-comment/${commentId}`, {
    meta: {},
    payload: {},
  });
}

type CommentPostProps = {
  articleId: number;
  body: string;
};

export function editNewsComment({
  articleId,
  commentId,
  body,
}: CommentPostProps & { commentId: number }) {
  return apiClient.post(`/v1/news/${articleId}/edit-comment/${commentId}`, {
    meta: {},
    payload: {
      body,
    },
  });
}

export function toggleCommentReaction(
  articleId: number,
  commentId: number,
  reactionTypeId: number,
) {
  return apiClient.post(
    `/v1/news/${articleId}/toggle-comment-reaction/${commentId}`,
    {
      meta: {},
      payload: {
        reaction_type_id: reactionTypeId,
      },
    },
  );
}

export function postComment({
  articleId,
  parentId,
  body,
}: CommentPostProps & { parentId?: number }) {
  return apiClient.post(`/v1/news/${articleId}/post-comment`, {
    meta: {},
    payload: {
      body,
      parent_id: parentId,
    },
  });
}

export function getNews({
  categoryId,
  pageParam,
  tag,
}: {
  categoryId?: number;
  pageParam?: number;
  tag?: string;
}) {
  const queryParams = new URLSearchParams();
  queryParams.set("p", "" + pageParam);
  if (categoryId) queryParams.set("category", "" + categoryId);
  if (tag) queryParams.set("tag", tag);

  return apiClient.get<ServerListResponse<Article>>(
    `/v1/news?${queryParams.toString()}`,
  );
}
